import {Injectable} from '@angular/core';
import {Table, TableLiteDto} from '@tj/tj-dmp-lib-api';
import * as _ from 'lodash';
import {SelectItem} from 'primeng/api';

export interface ResultFind {
    depth: number;
    value: any;
    map: any;
}


@Injectable({
    providedIn: 'root',
})
export class TableUiService {

    debug = false;

    getList(tables: TableLiteDto[] | Table[]): Array<Array<string>> {
        const map = this.buildMap(tables);
        if (map) {
            let list = this.append([], map);
            list = this.inverseList(list);
            return list;
        }
        return [];
    }

    getSelectItemListTables(tables: TableLiteDto[] | Table[]): SelectItem[] {
        const list: Array<Array<string>> = this.getList(tables);

        const items: SelectItem[] = [{
            label: '...',
            value: null
        }];
        list.forEach(codeTables => {
            const name = this.buildNameTables(codeTables, tables);
            items.push({
                label: name,
                value: codeTables
            });
        });
        return items;
    }

    private buildNameTables(codeTables: string[], tables: TableLiteDto[] | Table[]) {
        const names: string[] = [];
        codeTables.forEach(code => {
            const table = tables.find(i => i.code === code);
            if (table.label) {
                names.push(table.label);
            } else {
                names.push(table.code);
            }
        });
        //
        const name = names.join(' > ');
        return name;
    }

    private inverseList(list: Array<string>) {
        const resul: Array<string> = [];
        if (list) {
            list.forEach(item => {
                resul.push(_.reverse(item));
            });
        }
        return resul;
    }

    private append(items: Array<string>, map): Array<any> {
        if (map == null || map.size === 0) {
            return [items];
        }
        const result = [];
        for (const [key, value] of map) {
            const itemsClone = Object.assign([], items);
            itemsClone.push(key);
            const resultItems: Array<any> = this.append(itemsClone, value);
            result.push(...resultItems);
        }
        return result;
    }

    buildMap(tables: TableLiteDto[] | Table[]) {
        if (tables == null || tables.length === 0) {
            return null;
        }
        const maMap = new Map();
        tables.forEach(t => {
            const tMap = new Map();
            if (t.tableDependencies) {
                t.tableDependencies
                    .forEach(tDep => {
                        const rf = this.findValueForItemMap(maMap, tDep.table);
                        if (rf) {
                            maMap.delete(tDep.table);
                            tMap.set(tDep.table, rf.value);
                        } else {
                            tMap.set(tDep.table, null);
                        }
                    });
            }
            //
            const resultFind = this.findValueForItemMap(maMap, t.code);
            if (resultFind) {
                resultFind.map.set(t.code, tMap);
            } else {
                maMap.set(t.code, tMap);
            }

        });

        if (this.debug) {
            console.log(maMap);
        }
        return maMap;
    }

    private findValueForItemMap(map: any, keyFind: string, depth = 0): ResultFind {
        if (map == null) {
            return null;
        }
        let result: ResultFind = null;
        for (const [key, value] of map) {
            if (keyFind === key) {
                result = {
                    depth,
                    value,
                    map
                };
            } else {
                const temp = this.findValueForItemMap(value, keyFind, depth + 1);
                if (temp) {
                    return temp;
                }
            }
        }
        return result;
      }

}


